module.exports = __webpack_public_path__ + "static/assets/954db77158548ee8654dc468c9b6ccb4.png";